export default __webpack_public_path__ + "static/media/Circulation_ Inject.f8f9ada0.png";